const langApp = window.$ENV.LANG_APP;
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pl from './pl.json';
import de from './de.json';
import CustomFormatter from './customFormatter';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: langApp,
  formatter: new CustomFormatter(),
  messages: {
    de,pl,
  },
  silentTranslationWarn: true,
});

export default i18n;
